module.exports = __webpack_public_path__ + "static/media/cockroach(3).f25c3ab1.PNG";